import clsx from 'clsx'

import s from './Radio.module.scss'
import type { RadioProps } from './Radio.props'

export function Radio({ label, icon, className, ...props }: RadioProps) {
  return (
    <label>
      <input
        className={s.input}
        {...props}
        type="radio"
      />
      <span className={clsx(s.wrapper, className, { [s.withIcon]: !!icon })}>
        <span className={s.iconWrapper}>
          {!!icon && (
            <img
              src={icon}
              alt="Icon"
              width={44}
              height={44}
              className={s.icon}
            />
          )}
          <span className={s.control} />
        </span>
        <span className={s.label}>{label}</span>
      </span>
    </label>
  )
}
